<template>
  <div class="call-to-action">
    <h2>Get Your Corner Today</h2>
    <button class="btn btn-white" @click="$bvModal.show('video-modal')">
      Watch Video
    </button>
  </div>
</template>

<script>
export default {
  name: "Calltoaction"
};
</script>

<style lang="scss" scoped>
.call-to-action {
  min-height: 220px;
  background-image: url("../../../assets/img/sessions/call-to-action-bg.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 38px;
    color: #ffffff;
    margin-bottom: 16px;
  }
  .btn-white {
    height: 43px;
    width: 143px;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.08em;
    color: #557efb;
    background-color: #fff;
    padding-left: 15px;
    padding-right: 15px;
    &:hover {
      box-shadow: 0 13px 27px 0 rgba(255, 255, 255, 0.25);
      &:after,
      &:before {
        content: none;
      }
    }
  }
}
</style>
